import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";

import PreorderDetailView from "./PreorderDetailView";

const mapStateToProps = (_state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(PreorderDetailView),
);
